import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'block-insert', ['START']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'blocked_slots',
    'insertions',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/blockslot-insert-req.js